import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSwapHorizontal(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSwapHorizontal);
export default ForwardRef;
